import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = ["id"]
const _hoisted_3 = {
  key: 0,
  class: "modal-dialog modal-dialog-centered modal-xl"
}
const _hoisted_4 = { class: "modal-content" }
const _hoisted_5 = { class: "modal-body hkkd-wistia--video" }

import { ref, useTemplateRef, onMounted, onUnmounted, watch, nextTick } from 'vue'
  import { useWindowSize, usePointerSwipe, useMediaQuery, onClickOutside, useTimeout } from '@vueuse/core'
  import Story from '../../models/story.model'
  import WistiaVideoPlayer from './wistia-video-player.vue'

  interface Props {
    wistiaVideoId: String
  }

  
export default /*@__PURE__*/_defineComponent({
  __name: 'wistia-video-modal',
  props: {
    wistiaVideoId: {}
  },
  emits: ["active"],
  setup(__props: any, { emit: __emit }) {

  const props = __props
    const emit = __emit

  const renderComponent = ref(true);

  onMounted( ()  => {
  })

  const forceRender = async () => {
    if(renderComponent?.value) {
      renderComponent.value = false;
      await nextTick();
      renderComponent.value = true;
    }
  }

  onUnmounted( () => {
  })

return (_ctx: any,_cache: any) => {
  return (_ctx.wistiaVideoId)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "hkkd-wistia--modal-container",
        id: `${ _ctx.wistiaVideoId }`
      }, [
        (_ctx.wistiaVideoId)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "hkkd-wistia--modal modal fade",
              id: `hkkd-wistia--modal-${ _ctx.wistiaVideoId }`,
              "aria-hidden": "true",
              tabindex: "-1"
            }, [
              (renderComponent.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                    _createElementVNode("div", _hoisted_4, [
                      _cache[0] || (_cache[0] = _createElementVNode("div", { class: "modal-header" }, [
                        _createElementVNode("button", {
                          type: "button",
                          class: "btn-close",
                          "data-bs-dismiss": "modal",
                          "aria-label": "Close"
                        })
                      ], -1)),
                      _createElementVNode("div", _hoisted_5, [
                        (renderComponent.value)
                          ? (_openBlock(), _createBlock(WistiaVideoPlayer, {
                              key: 0,
                              "video-id": _ctx.wistiaVideoId,
                              "auto-play": true,
                              "aspect-ratio": 'aspect-ratio-16-9'
                            }, null, 8, ["video-id"]))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ], 8, _hoisted_2))
          : _createCommentVNode("", true)
      ], 8, _hoisted_1))
    : _createCommentVNode("", true)
}
}

})